/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlDirectoryUser } from './ControlDirectoryUser';
import {
    ControlDirectoryUserFromJSON,
    ControlDirectoryUserFromJSONTyped,
    ControlDirectoryUserToJSON,
} from './ControlDirectoryUser';
import type { ControlDomain } from './ControlDomain';
import {
    ControlDomainFromJSON,
    ControlDomainFromJSONTyped,
    ControlDomainToJSON,
} from './ControlDomain';
import type { ControlEndpoint } from './ControlEndpoint';
import {
    ControlEndpointFromJSON,
    ControlEndpointFromJSONTyped,
    ControlEndpointToJSON,
} from './ControlEndpoint';
import type { ControlFile } from './ControlFile';
import {
    ControlFileFromJSON,
    ControlFileFromJSONTyped,
    ControlFileToJSON,
} from './ControlFile';
import type { ControlIP } from './ControlIP';
import {
    ControlIPFromJSON,
    ControlIPFromJSONTyped,
    ControlIPToJSON,
} from './ControlIP';
import type { ControlLocation } from './ControlLocation';
import {
    ControlLocationFromJSON,
    ControlLocationFromJSONTyped,
    ControlLocationToJSON,
} from './ControlLocation';
import type { ControlProcess } from './ControlProcess';
import {
    ControlProcessFromJSON,
    ControlProcessFromJSONTyped,
    ControlProcessToJSON,
} from './ControlProcess';
import type { ControlUserAgent } from './ControlUserAgent';
import {
    ControlUserAgentFromJSON,
    ControlUserAgentFromJSONTyped,
    ControlUserAgentToJSON,
} from './ControlUserAgent';

/**
 * 
 * @export
 * @interface ControlAssets
 */
export interface ControlAssets {
    /**
     * 
     * @type {Array<ControlDirectoryUser>}
     * @memberof ControlAssets
     */
    directory: Array<ControlDirectoryUser>;
    /**
     * 
     * @type {Array<ControlDomain>}
     * @memberof ControlAssets
     */
    domains: Array<ControlDomain>;
    /**
     * 
     * @type {Array<ControlEndpoint>}
     * @memberof ControlAssets
     */
    endpoints: Array<ControlEndpoint>;
    /**
     * 
     * @type {Array<ControlFile>}
     * @memberof ControlAssets
     */
    files: Array<ControlFile>;
    /**
     * 
     * @type {Array<ControlIP>}
     * @memberof ControlAssets
     */
    ips: Array<ControlIP>;
    /**
     * 
     * @type {Array<ControlLocation>}
     * @memberof ControlAssets
     */
    locations: Array<ControlLocation>;
    /**
     * 
     * @type {Array<ControlProcess>}
     * @memberof ControlAssets
     */
    processes: Array<ControlProcess>;
    /**
     * 
     * @type {Array<ControlUserAgent>}
     * @memberof ControlAssets
     */
    userAgents: Array<ControlUserAgent>;
}

/**
 * Check if a given object implements the ControlAssets interface.
 */
export function instanceOfControlAssets(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "directory" in value;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "endpoints" in value;
    isInstance = isInstance && "files" in value;
    isInstance = isInstance && "ips" in value;
    isInstance = isInstance && "locations" in value;
    isInstance = isInstance && "processes" in value;
    isInstance = isInstance && "userAgents" in value;

    return isInstance;
}

export function ControlAssetsFromJSON(json: any): ControlAssets {
    return ControlAssetsFromJSONTyped(json, false);
}

export function ControlAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'directory': ((json['directory'] as Array<any>).map(ControlDirectoryUserFromJSON)),
        'domains': ((json['domains'] as Array<any>).map(ControlDomainFromJSON)),
        'endpoints': ((json['endpoints'] as Array<any>).map(ControlEndpointFromJSON)),
        'files': ((json['files'] as Array<any>).map(ControlFileFromJSON)),
        'ips': ((json['ips'] as Array<any>).map(ControlIPFromJSON)),
        'locations': ((json['locations'] as Array<any>).map(ControlLocationFromJSON)),
        'processes': ((json['processes'] as Array<any>).map(ControlProcessFromJSON)),
        'userAgents': ((json['userAgents'] as Array<any>).map(ControlUserAgentFromJSON)),
    };
}

export function ControlAssetsToJSON(value?: ControlAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'directory': ((value.directory as Array<any>).map(ControlDirectoryUserToJSON)),
        'domains': ((value.domains as Array<any>).map(ControlDomainToJSON)),
        'endpoints': ((value.endpoints as Array<any>).map(ControlEndpointToJSON)),
        'files': ((value.files as Array<any>).map(ControlFileToJSON)),
        'ips': ((value.ips as Array<any>).map(ControlIPToJSON)),
        'locations': ((value.locations as Array<any>).map(ControlLocationToJSON)),
        'processes': ((value.processes as Array<any>).map(ControlProcessToJSON)),
        'userAgents': ((value.userAgents as Array<any>).map(ControlUserAgentToJSON)),
    };
}

